import { MenuApi, FrontRoomApi } from '../../api-clients';
import { wrap } from '../../wrap';

export const menuMaterialApi = {
  index: wrap(MenuApi, MenuApi.prototype.indexMenuMaterialList),
  show: wrap(MenuApi, MenuApi.prototype.showMenuMaterial),
  create: wrap(MenuApi, MenuApi.prototype.createMenuMaterial),
  update: wrap(MenuApi, MenuApi.prototype.updateMenuMaterial),
  downloadFile: wrap(FrontRoomApi, FrontRoomApi.prototype.downloadContent),
};
